/**
 * outroConteudoBuilder — Outros Conteúdos (Material Didático — embed direto), BE módulo content.
 *
 * @since fase material-didático outro-conteudo (2026-07-16)
 */
import type { $Fetch } from 'ofetch';

import { HttpOutroConteudoGateway } from '@/infrastructure/http/HttpOutroConteudoGateway';
import {
  ListOutrosConteudos, CreateOutroConteudo, UpdateOutroConteudo, ArquivarOutroConteudo,
} from '@/application/usecase/OutroConteudoUseCaseImpl';

export function buildOutroConteudoSlice(httpClient: $Fetch) {
  const gateway = new HttpOutroConteudoGateway(httpClient);

  const useCases = {
    listOutrosConteudos: new ListOutrosConteudos(gateway),
    createOutroConteudo: new CreateOutroConteudo(gateway),
    updateOutroConteudo: new UpdateOutroConteudo(gateway),
    arquivarOutroConteudo: new ArquivarOutroConteudo(gateway),
  };

  return { useCases };
}
